import {GET_CURRENT_USER, SET_CURRENT_USER} from 'reducers/currentUser';

export default function postRender(store) {
    let {dispatch} = store;

    if (window.__currentUser) {
        dispatch({type: SET_CURRENT_USER, user: window.__currentUser});
        window.__currentUser = null;
    } else {
        dispatch({type: GET_CURRENT_USER});
    }

    window.addEventListener('message', function (event) {
        if (event.data === 'refresh_current_user') {
            let {currentUser} = store.getState();
            if (!currentUser.isLoggedIn()) {
                dispatch({type: GET_CURRENT_USER});
            }
        }
    });
}


// WEBPACK FOOTER //
// ./src/postRender.js